/* src/app/shared/components/form-controls/ag-input-currency/ag-input-currency.component.scss */
select {
  border: none;
  border-right: 1px solid #c8c7cc;
  outline: 0;
  height: 100%;
  margin-right: 2px;
  width: 40px;
  -webkit-appearance: none;
  appearance: none;
  flex: none;
}
select:disabled {
  color: #333333;
  opacity: 1;
}
/*# sourceMappingURL=ag-input-currency.component.css.map */
